import { AlertTriangle, TrendingUp } from "lucide-react";
import { money, pct } from "./helpers";

export default function SummaryCard({ summary, belowTargetCount, marginTarget }) {
  return (
    <div className="bg-zinc-900 text-white rounded-xl p-5" data-testid="estimator-summary-card">
      <div className="grid grid-cols-4 gap-4">
        <SumBlock label="Customer price" value={money(summary.customer_price)} accent="orange" testid="summary-price" />
        <SumBlock label="Internal cost" value={money(summary.internal_cost)} testid="summary-cost" />
        <SumBlock label="Profit" value={money(summary.profit)} accent="green" testid="summary-profit" />
        <SumBlock
          label="Margin"
          value={pct(summary.margin_pct)}
          accent={summary.margin_pct < marginTarget && marginTarget > 0 ? "amber" : "green"}
          testid="summary-margin"
        />
      </div>
      {summary.service_call_fee > 0 && (
        <div className="mt-3 text-xs text-zinc-400">
          Includes service call fee <span className="font-mono-accent text-white">{money(summary.service_call_fee)}</span>
        </div>
      )}
      {belowTargetCount > 0 && (
        <div className="mt-3 flex items-center gap-2 text-xs text-amber-300 bg-amber-950/50 rounded-lg p-2" data-testid="margin-warning">
          <AlertTriangle className="w-4 h-4" /> {belowTargetCount} line{belowTargetCount > 1 ? "s" : ""} below your {marginTarget}% target margin.
        </div>
      )}
      {marginTarget === 0 && (
        <div className="mt-3 text-[11px] text-zinc-500 flex items-center gap-1">
          <TrendingUp className="w-3 h-3" /> Set a target margin in Estimator Settings to enable low-margin alerts.
        </div>
      )}
    </div>
  );
}

function SumBlock({ label, value, accent, testid }) {
  const cls = accent === "orange"
    ? "text-[#FF5A00]"
    : accent === "green"
      ? "text-emerald-400"
      : accent === "amber"
        ? "text-amber-400"
        : "text-white";
  return (
    <div>
      <div className="text-[10px] uppercase tracking-widest text-zinc-400">{label}</div>
      <div className={`font-heading text-2xl font-bold ${cls}`} data-testid={testid}>{value}</div>
    </div>
  );
}
